import script from "./UserMailRenewal.vue?vue&type=script&setup=true&lang=js"
export * from "./UserMailRenewal.vue?vue&type=script&setup=true&lang=js"

import "./UserMailRenewal.vue?vue&type=style&index=0&id=e8d5c778&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8d5c778"]])

export default __exports__